<template>
  <!-- 动态列表 -->
  <div class="bot-detail-left">
    <div class="bot-detail-left-center">
      <ul class="bot-detail-left-center-ul" v-if="botList">
        <li
          style="cursor: pointer"
          v-for="item in botList"
          :key="item.dictValue"
          :class="{ show: curtId == item.dictValue }"
          @click="upStatus(item.dictValue)"
        >
          {{ item.dictLabel }}
        </li>
      </ul>
      <div class="child-bot" v-if="recordList">
        <div v-for="item in recordList" :key="item.id">
          <div class="child-bot-left">
            <div class="child-bot-left-por">
              {{
                item.recordType == 1
                  ? '面访'
                  : item.recordType == 2
                    ? '跟进'
                    : item.recordType == 3
                      ? '查看'
                      : item.recordType == 4
                        ? '被带看'
                        : item.recordType == 5
                          ? '钥匙'
                          : item.recordType == 6
                            ? '其他'
                            : item.recordType == 8
                              ? '意向'
                              : '带看'
              }}
            </div>
            <div class="child-bot-left-name">
              <p class="name">
                {{
                  item.createByName.length > 7 ? item.createByName.substr(0, 7) + '...' : item.createByName
                }}
              </p>

              <div v-if="rentSaleType==1">
                <p class="desc" v-if="item.houseInfoVoList" style="display: flex; flex-wrap: wrap">
                  {{ item.recordType === '7' ? '带看了房源' : item.recordContent || ''
                  }}<span
                    v-for="(v, i) in item.houseInfoVoList"
                    :key="v.id"
                    @click="handleGohouse(v)"
                    class="houseCode"
                  >
                    <!-- {{ v.houseCode.substr(0, 7) }} -->
                    {{ v.shopName }}
                    <span v-if="!(item.houseInfoVoList.length - 1 === i)">、</span>
                  </span>
                </p>
                <p class="desc" v-else>{{ item.recordContent }}</p>
              </div>
              <div v-if="rentSaleType==2">

                <p class="desc" v-if="item.houseInfoSaleVoList" style="display: flex; flex-wrap: wrap">
                  {{ item.recordType === '7' ? '带看了房源' : item.recordContent || '' }}
                  <span
                    v-for="(v, i) in item.houseInfoSaleVoList"
                    :key="v.id"
                    @click="handleGohouse(v)"
                    class="houseCode"
                  >
                    <!-- {{ v.houseCode.substr(0, 7) }} -->
                    {{ v.shopName }}
                    <span v-if="!(item.houseInfoSaleVoList.length - 1 === i)">、</span>
                  </span>
                </p>
                <p class="desc" v-else>{{ item.recordContent }}</p>
              </div>
            </div>
          </div>

          <div class="child-bot-right">
            <p class="time">{{ item.createTime }}</p>
            <template v-if="item.accessoryFileList">
              <p
                v-if="item.recordType == 1"
                class="time downLoad"
                @click="handledownload(item.accessoryFileList)"
              >
                下载附件
              </p>
            </template>
          </div>
        </div>
      </div>
      <!-- 动态列表分页 -->

      <a-pagination
        style="text-align: right"
        v-if="total"
        size="big"
        :pageSize="query.pageSize"
        :current="query.pageNum"
        :showTotal="(total) => `共 ${total} 条`"
        :total="total"
        @change="pageChange"
      />
      <div v-else>
        <no-data></no-data>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        botList: {
            type: Array,
            default: () => []
        },
        recordList: {
            type: Array,
            default: () => []
        },
        rentSaleType: {
            type: [Number, String],
            default: 1
        },
        curtId: {
            type: [Number, String],
            default: ''
        },
        total: {
            type: [Number, String],
            default: 0
        },
        query: {
            type: Object,
            default: () => ({})
        }

    },
    watch: {
        botList: {
            handler (value) {
              console.log(value, '动态')
            },
            deep: true,
            immediate: true
        },
        rentSaleType: {
           handler () {},
            deep: true,
            immediate: true
        },
        recordList: {
            handler () {},
            deep: true,
            immediate: true
        },
        query: {
            handler () {},
            deep: true,
            immediate: true
        }
    },
    data () {
        return {

        }
    },
    methods: {
        // 看房
        handleGohouse (item) {
            this.$emit('handleGohouse', item)
        },
        // 下载
        handledownload (item) {
            this.$emit('handledownload', item)
        },
        // 动态分页改变
        pageChange (page, pageSize) {
            this.$emit('pageChange', page, pageSize)
        },
        // 更新状态
        upStatus (item) {
            this.$emit('upStatus', item)
        }

    }
}
</script>

<style lang="less" scoped>
.bot-detail-left {
        width: 48%;
        position: relative;
        border-radius: 3px;
        border: 2px solid #f2f6fc;
        display: flex;
        justify-content: center;

        .bot-detail-left-center {
          width: 98%;
          padding-top: 20px;
          & > ul {
            display: block;
            text-align: center;
            margin-top: 20px;
          }
          .bot-detail-left-center-ul {
            width: 80%;
            list-style: none;
            margin: 0 auto;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-left: 0px;
            .show {
              width: 70px;
              height: 30px;
              background-color: var(--ThemeColor);
              border-radius: 30px;
              line-height: 30px;
              text-align: center;
              color: white;
            }
            & > li {
              width: 70px;
              height: 30px;
              background-color: #cccccc;
              border-radius: 30px;
              line-height: 30px;
              margin-right: 10px;
              text-align: center;
              color: white;
            }
          }
          .child-bot {
            margin-top: 20px;
            & > div {
              display: flex;
              justify-content: space-between;
              padding: 10px 0;
              padding-left: 40px;
              .child-bot-left {
                flex: 1;
                display: flex;
                align-items: center;
                .child-bot-left-por {
                  width: 50px;
                  height: 50px;
                  background-color: #ccc;
                  line-height: 50px;
                  text-align: center;
                  border-radius: 50%;
                  color: #fff;
                }
                .child-bot-left-name {
                  flex: 1;
                  margin-left: 10px;
                  .name {
                    font-weight: 700;
                    color: #222;
                    font-size: 16px;
                  }
                  .desc {
                    // width: 300px;
                    // overflow: hidden;
                    // white-space: nowrap;
                    // text-overflow: ellipsis;
                    display: flex;
                    flex-wrap: wrap;
                    .houseCode {
                      display: flex;
                      // width: 100px;
                      cursor: pointer;
                      color: blue;
                      overflow: hidden;
                    }
                  }
                }
              }
              .child-bot-right {
                width: 147px;
                .time {
                  margin-right: 20px;
                }
                .downLoad {
                  cursor: pointer;
                  text-align: right;
                  color: var(--ThemeColor);
                }
              }
            }
          }
          & > .img {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .ant-pagination {
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
}
</style>
